<template>
  <v-container grid-list-lg>
    <v-layout row wrap justify-center align-center>
      <v-flex xl8 lg10 md12 xs12>
        <v-card id="trainers" flat class="transparent" height="100"></v-card>
        <div class="text-xs-center">
          <h1 class="mb-3 primary--text">
            {{ trans('Meet Our Trainers') }}
          </h1>
        </div>
        <v-card flat class="transparent" height="50"></v-card>

        <!-- kang -->
        <v-layout row wrap>
          <v-flex sm4 xs12>
            <v-card>
              <v-img @contextmenu.prevent="preventRightClick" aspect-ratio="1" :src="trainers.kang"></v-img>
            </v-card>
          </v-flex>
          <v-flex offset-sm1 sm7 xs12>
            <p><strong>{{ __('Dr. Meng-Chow Kang') }}</strong> {{ __('is the author of the CRC Press book: "Responsive Security - Be Ready to Be Secure", and Adjunct Associate Professor at Nanyang Technological University of Singapore. He is also the Head of Security Assurance for Amazon Web Services (AWS) in Asia Pacific, China, and Japan Regions. Prior to joining AWS, he was Director and Chief Information Security Officer of Cisco Systems Asia Pacific, China and Japan from Feb 2009 to June 2017. Dr Kang is the Chair for Singapore IT Standards Committee\'s Multi-Tiered Cloud Security Standards Working Group since 2012, and a Technical Security Advisor for Singapore National IoT Standards Technical Committee (since 2014). He was also a member of the (ISC)2 Board of Directors (2015 to 2017), Convenor of the Security Controls and Services Working Group in ISO/IEC JTC 1/SC 27 (2006 to 2012), and an Associate Rapporteur for ITU-T SG17 (2004-2008). Dr Kang received his MSc degree in Information Security from the Royal Holloway and Bedford New College, University of London, and PhD in Information Security Risk Management at the Southern Cross University, Australia. He has been a Certified Information Systems Security Professional (CISSP) since 1998. Courses taught by Meng-Chow Kang: Enterprise Information Security Management; NTU CE/CZ 4064 – Security Management')}}</p>
          </v-flex>
        </v-layout>

        <v-card flat class="transparent" height="100"></v-card>

        <!-- zaid -->
        <v-layout row wrap>
          <v-flex sm4 xs12>
            <v-card>
              <v-img @contextmenu.prevent="preventRightClick" aspect-ratio="1" :src="trainers.zaid"></v-img>
            </v-card>
          </v-flex>
          <v-flex offset-sm1 sm7 xs12>
            <p><strong>{{ __('Zaid Hamzah') }}</strong> {{ __('is a technology lawyer and strategic counsel who specialises in technology innovation, ICT/IP law, and cybersecurity law. He is currently an Adjunct Senior Fellow at the RSIS, Nanyang Technological University where he teaches cybersecurity law and cyberterrorism.') }} </p>

            <p>{{ __('With over 30 years of professional legal, business, and government experience, Zaid has served as Director at Microsoft, Chief Legal Officer at Telekom Malaysia, and Senior Legal Adviser to Singtel’s Joint Venture with Sony Pictures and Warner Brothers. He is currently a Senior Counsel (Consultant) at a New York Stock Exchange-listed company.') }}</p>

            <p>{{ __('Author of nine books, Zaid is admitted to practise law in Singapore and England and Wales. He graduated from the law school of the National University of Singapore and was awarded the Fulbright scholarship for his Master of Arts programme at the Fletcher School of Law and Diplomacy, Tufts University, USA.') }}</p>

            <p>{{ __('He is currently involved in legal analytics and artificial intelligence in law.') }}</p>

            <p><strong>{{ __('Website:') }}</strong>
              <a href="http://www.futurelaw.academy/">
                <span class="px-3">{{ __('Future Law Academy') }}</span>
              </a>
            </p>

            <p><strong>{{ __('Email:') }}</strong>
              <a href="mailto:zaid@alxlaw.com">
                <span class="px-3">{{ __('zaid@alxlaw.com') }}</span>
              </a>
            </p>
          </v-flex>
        </v-layout>

        <v-card flat class="transparent" height="100"></v-card>

        <!-- looi -->
        <v-layout row wrap>
          <v-flex sm4 xs12>
            <v-card>
              <v-img @contextmenu.prevent="preventRightClick" aspect-ratio="1" :src="trainers.looi"></v-img>
            </v-card>
          </v-flex>
          <v-flex offset-sm1 sm7 xs12>
            <p>
              {{ __('Admitted as an Advocate and Solicitor, Singapore,')}}
              <strong>{{ __('Looi Teck Kheong') }}</strong>
              {{ __('has over 30 years of professional experience spanning private practice as well as acting as in-house counsel.  With a deep interest in law and technology, Teck Kheong has played an active role as an industry practitioner in the areas of information technology, civil & commercial practice, and journalistic publication.') }}</p>

            <p>{{ __('He graduated with a Bachelor of Law degree from the National University of Singapore (NUS) and has Master degrees from NUS in Law, Public Policy (Lee Kuan Yew School of Public Policy) and Economic Policy & Development (Economics Faculty).') }}</p>
            <p>{{ __('Teck Kheong has advised tech start-ups and has contributed to the tech community in the areas of ecommerce, financial and regulatory technology, initial coin offerings as well as equity investment platform.') }}</p>

            <p><strong>{{ __('Email:') }}</strong>
              <a href="mailto:zaid@alxlaw.com">
                <span class="px-3">{{ __('tk.looi@gmail.com') }}</span>
              </a>
            </p>
          </v-flex>
        </v-layout>

        <v-card flat class="transparent" height="100"></v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import looi from '@/modules/CDA/About/assets/images/looi.png'
import zaid from '@/modules/CDA/About/assets/images/zaid.png'
import kang from '@/modules/CDA/About/assets/images/kang.png'

export default {
  name: 'Trainers',

  data () {
    return {
      trainers: {
        looi: looi,
        zaid: zaid,
        kang: kang,
      }
    }
  },

  mounted () {
    this.preventRightClick()
  },

  methods: {
    preventRightClick () {
      return false
    }
  }
}
</script>
